const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

export default config;
